import React from 'react'
import { motion } from "framer-motion"
import styles from './Feedback.module.scss'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Autoplay } from 'swiper/modules'
import "./Feedback.css"
import 'swiper/scss'
import "swiper/scss/pagination"
import "swiper/scss/navigation"
import img from '../../image/Feedback/img.webp'
import Annotation from '../Annotation/Annotation'

const boxAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: 1}
    } 
}


const Feedback = () => {

    return (
        <motion.section 
            className={styles.main}
            id='otzyvy'
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.1, once: true}}
            >
            <motion.div className={styles.box} variants={boxAnimation}>
                <h2 className={styles.title}>ОТЗЫВЫ НАШИХ КЛИЕНТОВ</h2>
                <Annotation/>
                    <div className={styles.slider}>
                        <Swiper
                                spaceBetween={10}
                                slidesPerView={1.3}
                                centeredSlides={true}
                                loop={true}
                                autoplay={{
                                    delay: 6000,
                                    disableOnInteraction: false,
                                }}
                                pagination={{
                                    type: 'fraction'
                                }}
                                breakpoints={{

                                    1400: {
                                        slidesPerView: 1.5,
                                        spaceBetween: 5,
                                    },

                                    768: {
                                        slidesPerView: 1.2,
                                        spaceBetween: 5,
                                    },

                                    425: {
                                        slidesPerView: 1,
                                        spaceBetween: 5,
                                    },

                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 5,
                                    },
                                }}
                                modules={[Pagination, Autoplay]}
                                className="mySwiper"
                                >
                            <SwiperSlide>
                                <div className={styles.cell}>
                                    <div className={styles.item}>
                                        <p className={styles.subtitle}>Артём</p>
                                        <p className={styles.comment}>17.05.2025</p>
                                        <img className={styles.image} src={img} alt = 'звездочки'/>
                                        <p className={styles.comment}>Комментарий</p>
                                        <p className={styles.text}>Крыша покрыта идеально, работой кровельщиков доволен, претензий к мастерам не имею. Закончили немного с опозданием из-за погодных условий, что заранее со мной согласовано. Гарантия на работу получена, но, надеюсь, что воспользоваться ей не придется!</p>
                                    </div>
                                </div>
                            </SwiperSlide>        
                            <SwiperSlide>
                                <div className={styles.cell}>
                                    <div className={styles.item}>
                                        <p className={styles.subtitle}>Максим</p>
                                        <p className={styles.comment}>13.09.2024</p>
                                        <img className={styles.image} src={img} alt = 'звездочки'/>
                                        <p className={styles.comment}>Комментарий</p>
                                        <p className={styles.text}>Работа выполнена качественно и в установленные сроки. В процессе работы были даны компетентные рекомендации. Руководитель бригады всегда был на связи, проявил гибкий подход к выполнению работ, выдержанный и приятный в разговоре, сделал хорошую скидку. Работой доволен, рекомендую.</p>                              
                                    </div>
                                </div>
                            </SwiperSlide>        
                            <SwiperSlide>
                                <div className={styles.cell}>
                                    <div className={styles.item}>
                                        <p className={styles.subtitle}>Анастасия</p>
                                        <p className={styles.comment}>23.08.2024</p>
                                        <img className={styles.image} src={img} alt = 'звездочки'/>
                                        <p className={styles.comment}>Комментарий</p>
                                        <p className={styles.text}>Спасибо большое строительной бригаде,делавшей у нас крышу.Отвечают быстро,созвонились, договорились о встрече. Мастер приехал всё осмотрел, замерил. Мы сказали свои пожелания, что и как хотим.При выполнении работ всё было учтено и сделано.В процессе работы, если возникали вопросы-исполнитель звонил, говорил, предупреждал или предлогал альтернативу. Вся бригада компетентная, готовая сотрудничать и знающая своё дело.Мы остались довольны, бригада отличная,молодцы.Что касается цены-дорого или нет, сказать не могу.сравнивать не с чем.Но по нынешним расценкам,я думаю приемлимо.</p>                              
                                    </div>
                                </div>
                            </SwiperSlide>        
                            <SwiperSlide>
                                <div className={styles.cell}>
                                    <div className={styles.item}>
                                        <p className={styles.subtitle}>Антон</p>
                                        <p className={styles.comment}>08.07.2024</p>
                                        <img className={styles.image} src={img} alt = 'звездочки'/>
                                        <p className={styles.comment}>Комментарий</p>
                                        <p className={styles.text}>Уже давно крыша протекала, пытались латать сами, но тщетно. Решили обратиться к профессионалам, не смотря на то, что форма крыши скатная, справились на отлично. Предоставили все документы, сумма, которая была прописана в договоре, полностью совпала с реальной стоимостью.</p>                              
                                    </div>
                                </div>
                            </SwiperSlide>        
                            <SwiperSlide>
                                <div className={styles.cell}>
                                    <div className={styles.item}>
                                        <p className={styles.subtitle}>Сергей</p>
                                        <p className={styles.comment}>27.03.2025</p>
                                        <img className={styles.image} src={img} alt = 'звездочки'/>
                                        <p className={styles.comment}>Комментарий</p>
                                        <p className={styles.text}>Обратились в данную организацию для замены кровли на доме. Необходимо было демонтировать старую кровлю, добавить дополнительные лаги, утеплить и покрыть металлочерепицей. Бригада из трех человек и их руководитель сделали все оперативно,  очень качественно, со знанием своего дела.  Материалы и их доставку организовывает сам подрядчик. Материал очень качественный, лаги ребята обработали огне-биозащитой. Отдельное спасибо за оперативность. По договору срок исполнения 8 дней , бригада выполнила все работы за 4 дня. Большая благодарность ребятам за проделанную работу. </p>                              
                                    </div>
                                </div>
                            </SwiperSlide>           
                            <SwiperSlide>
                                <div className={styles.cell}>
                                    <div className={styles.item}>
                                        <p className={styles.subtitle}>Анна Каверина</p>
                                        <p className={styles.comment}>18.09.2024</p>
                                        <img className={styles.image} src={img} alt = 'звездочки'/>
                                        <p className={styles.comment}>Комментарий</p>
                                        <p className={styles.text}>В ходе некачественного ремонта предыдущей бригадой строителей была, как оказалось, повреждена крыша дома. После начала дождей выявились протечки в нескольких местах. Обратились в несколько мест для выбора бригады для устранения. Не смотря на то, что стоимость расчетная оказалась немного выше, чем мы ожидали, мы выбрали эту бригаду за подход и нацеленность на помощь клиенту. В ходе работ ребята все сделали качественно и быстро. Нашли и сами доставили недостающие материалы. И за ту же стоимость еще и усилили нам стропильную систему на веранде и заменили мембрану. А самое главное, оставили после себя чисто убранное место работ ( не как у многих, после которых еще бригаду уборщиков надо вызывать).Спасибо за выполненную работу. Однозначно рекомендуем.</p>                              
                                    </div>
                                </div>
                            </SwiperSlide>        
                            <SwiperSlide>
                                <div className={styles.cell}>
                                    <div className={styles.item}>
                                        <p className={styles.subtitle}>Ярослава Волкова</p>
                                        <p className={styles.comment}>15.05.2025</p>
                                        <img className={styles.image} src={img} alt = 'звездочки'/>
                                        <p className={styles.comment}>Комментарий</p>
                                        <p className={styles.text}>Огромное спасибо вам за то, что перекрыли крышу нашего дома с утеплением. Мы ощущаем, как уровень комфорта в нашем доме вырос. Работа выполнена профессионально и в срок. Спасибо вам за вашу преданность и ответственность!</p>                              
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </motion.div>
        </motion.section>
    )
}

export default Feedback